import {
  TweenMax,
  TimelineMax,
  Sine
} from "gsap";
//  Power2, Elastic, CSSPlugin ,Tweenmax
export function play() {

  TweenMax.set(`[data-name="drone"]`, {
    transformOrigin: "50% 50%"
  })

  var tl = new TimelineMax()
  tl.to(`[data-name="drone"]`, 3, {
    rotate: 5,
    y: -50
  }).to(`[data-name="drone"]`, 3, {
    rotate: -5,
    y: 10
  })
  tl.repeat(-1).yoyo(true)


  // TweenMax.staggerTo(`[data-name="drone"] ellipse.bb0042f6-adb7-44c7-8314-eaee37b1a467`, 0.2, {
  //   opacity: 0.3
  // }, 0.3).repeat(-1).yoyo(true)



  TweenMax.to(`[data-name="website"] `, 2, {
    y: -30,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="website"] line, [data-name="website"] polygon `, {
    opacity: 1
  })
  TweenMax.staggerFrom(`[data-name="website"] line, [data-name="website"] polygon `, 0.7, {
    opacity: 0
  }, 0.2).repeat(-1)

  TweenMax.to(`[data-name="people_ipad"] .a1e876b7-2ca6-4a5a-9d57-32239f44723c, .bef2c452-ab65-455d-8a9f-1e1dca20a5b8`, 1.5 , {
    y: -5,
    ease: Sine.easeInOut
  }, 0.5).repeat(-1).yoyo(true)

  TweenMax.to(`[data-name="people_ipad"] .a1e876b7-2ca6-4a5a-9d57-32239f44723c`, 1.5 , {
    fill: 'rgba(0,0,0,1)',
    ease: Sine.easeInOut
  }, 0.2).repeat(-1).yoyo(true)

  TweenMax.to(`[data-name="buildings_musuem"] 
              .e60e2e27-53e0-4811-8c6b-d84bc0e93c8f:nth-child(9), 
              .e60e2e27-53e0-4811-8c6b-d84bc0e93c8f:nth-child(10), 
              .e60e2e27-53e0-4811-8c6b-d84bc0e93c8f:nth-child(13),
              .e60e2e27-53e0-4811-8c6b-d84bc0e93c8f:nth-child(11),
              .e60e2e27-53e0-4811-8c6b-d84bc0e93c8f:nth-child(12)
              `, 1.5 , {
    fill: 'rgba(255,255,255,1)',
    ease: Sine.easeInOut
  }, 0.2).repeat(-1).delay(1.5).yoyo(true)

  TweenMax.staggerTo(`[data-name="buildings_02_windows"] polygon`, 2 , {
    fill: 'rgba(255,255,0,1)',
    ease: Sine.easeInOut
  }, 0.1).repeat(-1)

  TweenMax.staggerTo(`[data-name="buildings_04_windows"] polygon`, 2 , {
    fill: 'rgba(255,255,100,1)',
    ease: Sine.easeInOut
  }, 0.1).delay(3).repeat(-1)

  

}